// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-fd63fb3e]{border-radius:0;color:var(--light-color)}.dropdown-toggle[data-v-fd63fb3e]{padding:0}.dropdown-toggle[data-v-fd63fb3e]:after{display:none}.collapsible[data-v-fd63fb3e]{max-height:0;transition:max-height .25s ease-out;overflow:hidden}.collapsible.expanded[data-v-fd63fb3e]{max-height:700px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
